var map = {
	"./baix_llobregat.svg": 5313,
	"./catalunya_nord.svg": 7428,
	"./cccc.svg": 640,
	"./colles_barcelonines.svg": 9626,
	"./colles_castelleres_internacionals.svg": 5047,
	"./colles_de_l_eix.svg": 8534,
	"./colles_illes_balears.svg": 4845,
	"./colles_nord.svg": 3202,
	"./colles_sud.svg": 5523,
	"./colles_upc.svg": 2885,
	"./discontinues.svg": 7418,
	"./sant_neo.svg": 6225,
	"./zona_tradicional.svg": 4929
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3042;